module.exports = __webpack_public_path__ + "img/flyingJet.f07bb7cd.png";